import './AboutBlock.scss';

function AboutBlock() {
    return (
        <div className='about-section'>
            <p>Outside of work, I am an avid Romance reader and a lover of "grandma hobbies" like
               cross-stitching and crocheting. I don't go anywhere without a book, and if asked, will 
               tell you about any number of craft projects I am planning. I am always up for a trip 
               to the movie theaters or even just a rewatch of a beloved movie with family and friends. 
               You can also find me watching Youtube videos of whichever subject I am fixated on at the time
               (currently medieval European history and coats of arms).
            </p>
        </div>
    );
}

export default AboutBlock